import BaseProxy from './Base';
import Vue from 'vue';

class UserProxy extends BaseProxy {
  constructor(parameters = {}) {
    super('me', parameters);
  }

  getProfile() {
    return this.load();
  }

  setProfile(params) {
    return this.submit('put', `/${this.endpoint}`, params);
  }

  login(params) {
    return this.submit('post', '/api/v1/login', params);
  }

  logout() {
    return Vue.$http.get('/api/v1/logout');
  }
}

export default UserProxy;
